import { DropdownItem } from '@frk/eds-components';
import { SeriesOptionsType } from 'highcharts';
import { GermanCalculatorResult } from './model/german-calculator';

export interface GermanCalculatorState {
  data?: GermanCalculatorResult;
  config: GermanCalculatorConfig;
  hasLoadedFullFeed?: boolean;
}

export interface GermanCalculatorConfig {
  formValues: GermanCalculatorFormValues;
  defaultResultType: GermanCalculatorResultType;
  summaryData?: GermanCalculatorSummaryData[];
  chartData?: GermanCalculatorChartData;
  tableData?: GermanCalculatorTableData;
}

export interface GermanCalculatorFormValues {
  calculationTypeItems: DropdownItem[];
  bindValues: GermanCalculatorFormBindValues;
  maxValues: GermanCalculatorFormMaxValues;
  maxLabelValues: GermanCalculatorFormMaxLabelValues;
  invalidLabelValues: GermanCalculatorFormInvalidLabelValues;
  installmentPeriodItems?: DropdownItem[];
  perpetualAnnuityItems?: DropdownItem[];
  payoutItems?: DropdownItem[];
}

export interface GermanCalculatorFormBindValues {
  defaultCalculationType?: GermanCalculationType;
  initialContribution?: string;
  finalCapital?: string;
  initialSalesCharge?: string;
  investmentPeriod?: string;
  interestRate?: string;
  savingsRate?: string;
  defaultInstallmentPeriod?: GermanCalculatorInstallmentPeriod;
  pension?: string;
  defaultPerpetualAnnuity?: GermanCalculatorPerpetualAnnuity;
  defaultPayout?: GermanCalculatorInstallmentPeriod;
}

export interface GermanCalculatorFormMaxValues {
  maxInitialContribution?: string;
  maxFinalCapital?: string;
  maxSalesCharge?: string;
  maxInvestmentPeriod?: string;
  maxInterestRate?: string;
  maxSavingsRate?: string;
  maxPension?: string;
}

export interface GermanCalculatorFormMaxLabelValues {
  maxInitialContributionLabel?: string;
  maxFinalCapitalLabel?: string;
  maxSavingsRateLabel?: string;
  maxPensionLabel?: string;
}

export interface GermanCalculatorFormInvalidLabelValues {
  initialSalesChargeInvalidText?: string;
  interestRateInvalidText?: string;
}

export interface GermanCalculatorAPIRequestParams {
  calculationType?: string;
  initialBalance?: string;
  finalBalance?: string;
  initialSalesCharge?: string;
  durationYears?: string;
  durationDays?: string;
  interestRate?: string;
  instalmentAmount?: string;
  instalmentFrequency?: string;
  withdrawalFrequency?: string;
  perpetuity?: string;
  withdrawalAmount?: string;
}

export interface GermanCalculatorSummaryData {
  label: string;
  value: string;
  valueType: GermanCalculatorSummaryDataValueType;
  showLegend: boolean;
  legendColor?: string;
  currencySymbol?: string;
}

export enum GermanCalculatorSummaryDataValueType {
  'PERIOD' = 'PERIOD',
  'RATE' = 'RATE',
  'AMOUNT' = 'AMOUNT',
}

export interface GermanCalculatorChartData {
  chartTitle: string;
  proximalPlacementTop: string;
  proximalPlacementBottom: string;
  caveatPlacement: string;
  tooltip: string;
  series: SeriesOptionsType[];
  xAxisCategories: string[];
  xAxisLabel: string;
  yAxisLabel: string;
}

export interface GermanCalculatorTableData {
  headers: string[];
  body: string[][];
}

export interface GermanCalculatorTotalPages {
  count: number;
}

export enum GermanCalculatorType {
  'ONE_TIME_INVESTMENT',
  'SAVINGS_PLAN',
  'WITHDRAWL_PLAN',
}

export enum GermanCalculationType {
  'INITIAL_CAPITAL' = 'INITIAL_CAPITAL',
  'SAVINGS_RATE' = 'SAVINGS_RATE',
  'TERM' = 'TERM',
  'INTEREST_RATE' = 'INTEREST_RATE',
  'END_VALUE' = 'END_VALUE',
  'PENSION' = 'PENSION',
}

export enum GermanCalculatorResultType {
  'CHART',
  'TABLE',
}

export type GermanCalculatorBRConfig = GermanCalculatorFormBindValues &
  GermanCalculatorFormMaxValues & {
    defaultResultType: GermanCalculatorResultType;
  };

export enum GermanCalculatorInstallmentPeriod {
  'YEARLY' = 'YEARLY',
  'HALF_YEARLY' = 'HALF_YEARLY',
  'QUARTERLY' = 'QUARTERLY',
  'BI_MONTHLY' = 'BI_MONTHLY',
  'MONTHLY' = 'MONTHLY',
}

export enum GermanCalculatorPerpetualAnnuity {
  'YES' = 'YES',
  'NO' = 'NO',
}
